module.exports = __webpack_public_path__ + "img/vertical_4_1_8017.9caf098a.png";